import "maplibre-gl/dist/maplibre-gl.css";
import { LocaleProvider } from "./i18n";
import RestroomMap from "./components/RestroomMap";

export default function App() {
  return (
    <LocaleProvider>
      <RestroomMap />
    </LocaleProvider>
  );
}
